import {
  ChildrensBooks,
  GuidedToursForKids,
  KidHero,
  KidPhotoAndVideoSliderSection,
  Layout,
  MikadoFontFace,
  OnlineChildrensWorkshops,
} from '@common'
import { ISSRPageData } from '@interfaces'
import KIDS_STICKY_NAV from '@lib/const/kids-sticky-nav.const'
import { PageService } from '@services'
import { createNavLink } from '@utils'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const KidScreen = ({ pageData, global: { navigation } }: ISSRPageData) => {
  const { t } = useTranslation()
  const { locale, asPath } = useRouter()

  return (
    <Layout
      title={t('explore-art:kid.pageTitle')}
      navigation={navigation}
      path={asPath}
    >
      <MikadoFontFace />
      <KidHero activeFontFamily="mikado" navs={KIDS_STICKY_NAV} />
      {pageData.data.kidBooks && pageData.data.kidBooks.length > 0 && (
        <ChildrensBooks
          stickyId={KIDS_STICKY_NAV[0].href}
          sectionTitle={t('explore-art:kid.childrensBooks.title')}
          collection={pageData.data.kidBooks}
          activeFontFamily="mikado"
        />
      )}

      {pageData.data.workshopDescriptionHtmlContent &&
        pageData.data.workshops && (
          <OnlineChildrensWorkshops
            stickyId={KIDS_STICKY_NAV[1].href}
            workshopDescriptionHtmlContent={
              pageData.data.workshopDescriptionHtmlContent
            }
            activeFontFamily="mikado"
            collection={pageData.data.workshops}
          />
        )}

      {pageData.data.gallery && (
        <KidPhotoAndVideoSliderSection
          data={pageData.data.gallery}
          buttonLabel={t('explore-art:kid.viewPastPrograms')}
          buttonUrl={`${createNavLink(
            'exhibitionAndEvent',
            locale
          )}?activeCollection=workshop&sort=past&page=1`}
        />
      )}

      {(pageData.data.guidedToursDescriptionHtmlContent ||
        pageData.data.guidedToursUrl) && (
        <GuidedToursForKids
          stickyId={KIDS_STICKY_NAV[2].href}
          tourDescriptionHtmlContent={
            pageData.data.guidedToursDescriptionHtmlContent
          }
          tourUrl={pageData.data.guidedToursUrl}
        />
      )}
    </Layout>
  )
}

export default KidScreen

export async function getServerSideProps({ locale }) {
  const pageData = await PageService.getKidPage(locale)

  return {
    props: { pageData },
  }
}
